import { Layer, Source } from 'react-map-gl';

const IntermediateLayers = () => {
  const geojson: GeoJSON.FeatureCollection = {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        properties: {
          title: 'My Location',
        },
        geometry: {
          type: 'Point',
          coordinates: [-122.4, 37.8], // San Francisco
        },
      },
    ],
  };

  return (
    <Source id="symbol-source" type="geojson" data={geojson}>
      <Layer id={`background-layer`} beforeId="foreground-layer" type="symbol" />
      <Layer id={`foreground-layer`} beforeId="analytic-layer" type="symbol" />
      <Layer id={`analytic-layer`} beforeId="sky" type="symbol" />
    </Source>
  );
};

export default IntermediateLayers;
